<template>
  <button @click="$emit('click')" class="card">
    <h4>{{ sectionTitle }}</h4>
    <span>
      {{ `${numberOfQuestions} Pregunta(s)` }}
    </span>
  </button>
</template>

<script>
export default {
  name: "SectionCard",

  props: {
    sectionTitle: {
      required: true,
      type: String
    },

    numberOfQuestions: {
      required: true,
      type: Number
    }
  }
};
</script>

<style scoped>
.card {
  display: block;
  text-align: start;
  padding: var(--lengthMd2);
  background-color: white;
  border: 1px solid var(--grayColor2);
  border-radius: var(--lengthSm1);
  cursor: pointer;
}

span {
  margin-top: var(--lengthSm1);
  color: var(--fontColor3);
  font-size: 0.75rem;
  font-weight: var(--medium);
}

.btn-container {
  margin-left: auto;
  grid-gap: var(--lengthMd2);
  gap: var(--lengthMd2);
}
</style>
